var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 18.9577H7.49984C2.97484 18.9577 1.0415 17.0243 1.0415 12.4993V7.49935C1.0415 2.97435 2.97484 1.04102 7.49984 1.04102H11.6665C12.0082 1.04102 12.2915 1.32435 12.2915 1.66602C12.2915 2.00768 12.0082 2.29102 11.6665 2.29102H7.49984C3.65817 2.29102 2.2915 3.65768 2.2915 7.49935V12.4993C2.2915 16.341 3.65817 17.7077 7.49984 17.7077H12.4998C16.3415 17.7077 17.7082 16.341 17.7082 12.4993V8.33268C17.7082 7.99102 17.9915 7.70768 18.3332 7.70768C18.6748 7.70768 18.9582 7.99102 18.9582 8.33268V12.4993C18.9582 17.0243 17.0248 18.9577 12.4998 18.9577Z",
    fill: "#2F2F2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 8.95841H14.9998C12.1498 8.95841 11.0415 7.85007 11.0415 5.00007V1.66674C11.0415 1.41674 11.1915 1.18341 11.4248 1.09174C11.6582 0.991739 11.9248 1.05007 12.1082 1.22507L18.7748 7.89174C18.9498 8.06674 19.0082 8.34174 18.9082 8.57507C18.8082 8.8084 18.5832 8.95841 18.3332 8.95841ZM12.2915 3.17507V5.00007C12.2915 7.15007 12.8498 7.70841 14.9998 7.70841H16.8248L12.2915 3.17507Z",
    fill: "#2F2F2F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8335 11.459H5.8335C5.49183 11.459 5.2085 11.1757 5.2085 10.834C5.2085 10.4923 5.49183 10.209 5.8335 10.209H10.8335C11.1752 10.209 11.4585 10.4923 11.4585 10.834C11.4585 11.1757 11.1752 11.459 10.8335 11.459Z",
    fill: "#2F2F2F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16683 14.791H5.8335C5.49183 14.791 5.2085 14.5077 5.2085 14.166C5.2085 13.8243 5.49183 13.541 5.8335 13.541H9.16683C9.5085 13.541 9.79183 13.8243 9.79183 14.166C9.79183 14.5077 9.5085 14.791 9.16683 14.791Z",
    fill: "#2F2F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.24b3bb1eff8eb41a245a8652eb1f14c5.svg";
export { ForwardRef as ReactComponent };